import React, { useState } from 'react';
import { EmptyMessage, Load, LoadCenter } from 'ui/styled';
import CustomTablePagination from 'components/CustomTablePagination';
import { Card, CardContainer, CardItem, CardItemText, CardItemTitle } from './styled';

export default function CardsList({ columns, rows, loading, pagination, column, full, noShadow }) {
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {loading ? (
        <LoadCenter>
          <Load />
        </LoadCenter>
      ) : rows?.length ? (
        <CardContainer full={full}>
          {(pagination && rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, (page + 1) * rowsPerPage)
            : rows
          )?.map((row, rowIndex) => (
            <Card key={rowIndex} column noShadow={noShadow} full={full}>
              {columns?.map((item, colIndex) => (
                <CardItem key={colIndex} itemIndex={colIndex} column={item?.column || column} isLast={colIndex === columns.length - 1}>
                  <CardItemTitle>{item.title}</CardItemTitle>
                  {item.renderCell ? item.renderCell({ row }) : <CardItemText> {row[item.ref]} </CardItemText>}
                </CardItem>
              ))}
            </Card>
          ))}
        </CardContainer>
      ) : (
        <EmptyMessage>Nenhum registro encontrado</EmptyMessage>
      )}

      {pagination && (
        <CustomTablePagination
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </>
  );
}
